import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

/**
 * Komponent chroniący trasy przed dostępem bez uwierzytelnienia
 */
const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Jeśli trwa ładowanie stanu uwierzytelnienia, wyświetl loader
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress size={60} thickness={4} />
      </Box>
    );
  }

  // Jeśli użytkownik nie jest uwierzytelniony, przekieruj na stronę logowania
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Jeśli użytkownik jest uwierzytelniony, renderuj chronioną zawartość
  return <Outlet />;
};

export default ProtectedRoute;
